import React, { useEffect } from "react";
import classNames from "classnames";
import Styles from "./Payment.module.scss";
import { useNavigate, useLocation } from "react-router-dom";
import {
  getOneCompany,
  getPaymentCompany,
  getPaymentSummary,
  getSomeCompany,
  InvoicePrint,
  testDownloadS3,
} from "../BGService/kzgAPI";
import qs from "qs";

const Summary = () => {
  const navigate = useNavigate();
  const [paymentSummary, setPaymentSummary] = React.useState([]);
  const [companys, setCompanys] = React.useState([]);
  const [company, setCompany] = React.useState(null);
  const location = useLocation();
  // location.search 會得到 "?a=1&b=2"
  const queryParams = qs.parse(location?.search, { ignoreQueryPrefix: true });
  const caseId = atob(queryParams?.data);

  /**
   * Async Function
   */
  async function fetchPaymentSummary(company, caseId) {
    const response = await getPaymentSummary({
      company: company,
      caseId: caseId,
    });
    if (response.status === 50004) {
    } else if (response.status !== 200) {
      // navigate(`/payment_temp`);
    } else {
      setPaymentSummary(response.data);
    }
  }

  async function fetchPaymentCompany(caseId) {
    const response = await getPaymentCompany({
      caseId: caseId,
    });
    if (response.status === 50004) {
    } else if (response.status !== 200) {
      // navigate(`/payment_temp`);
    } else {
      const newReq = response.data.map((item) => ({
        id: item.company,
      }));
      fetchCompanySome(newReq);
    }
  }

  async function fetchCompanySome(companys) {
    const response = await getSomeCompany(companys);
    if (response.status === 50004) {
    } else if (response.status !== 200) {
      // navigate(`/payment_temp`);
    } else {
      setCompanys(response.data);
      setCompany(response.data[0]);
      localStorage.setItem("company", response.data[0].id);
      fetchPaymentSummary(response.data[0].id, caseId);
      // setPaymentSummary(response.data);
    }
  }
  async function fetchCompanyOne(company) {
    const response = await getOneCompany({ id: company });
    if (response.status === 50004) {
    } else if (response.status !== 200) {
      // navigate(`/payment_temp`);
    } else {
      setCompany(response.data);
      localStorage.setItem("company", response.data.id);
      fetchPaymentSummary(response.data.id, caseId);
      // setPaymentSummary(response.data);
    }
  }

  async function fetchReceipt(month, caseId, company) {
    const response = await testDownloadS3({
      month: month,
      caseId: caseId,
      company: company,
    });

    // window.open(response.data, "_blank");
    const link = document.createElement("a");
    link.href = response.data;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  async function FetchInvoice(month, caseId, company) {
    const response = await InvoicePrint({
      month: month,
      caseId: caseId,
      company: company,
    });

    // window.open(response.data, "_blank");
    const link = document.createElement("a");
    link.href = response.data;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handleDownload = (month, company) => {
    fetchReceipt(month, caseId, company);
  };

  const handleFetchInvoice = (month, company) => {
    FetchInvoice(month, caseId, company);
  };

  /**
   * use Effect
   */
  useEffect(() => {
    fetchPaymentCompany(caseId);
  }, []);
  // useEffect(() => {
  //   navigate("/systemRepair");
  // }, []);

  /**
   * Handling
   */
  const handleInfoClick = (month) => {
    console.log("handleInfoClick");
    localStorage.setItem("month", month);
    const data = caseId + "_" + month + "_" + company?.id;
    navigate("/payment_temp/info?data=" + btoa(data));
  };

  const handleCompanyChange = (event) => {
    fetchCompanyOne(event.target.value);
  };

  const maskName = (name) => {
    if (!name || name.length < 2) return name || "";

    if (name.length === 2) {
      return name[0] + "O";
    }

    const firstChar = name[0];
    const lastChar = name[name.length - 1];
    const middleO = "O".repeat(name.length - 2);

    return firstChar + middleO + lastChar;
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#e6ecef",
        marginTop: "2vh",
      }}
    >
      <div className={classNames("container")}>
        {/* <div
          className={classNames(Styles.payment__info__method__btn)}
          onClick={() => navigate(`/payment_temp`)}
        >
          <div
            style={{
              marginBottom: "1vh",
            }}
            className={classNames(Styles.payment__btn)}
          >
            回繳費頁面
          </div>
        </div> */}

        <div
          className={classNames(
            "col-sm-12",
            "col-md-12",
            "col-lg-12",
            Styles.payment__table__title,
            Styles["payment__table__title--center"],
          )}
        >
          所屬機構
          <div className={classNames(Styles.payment__table__input)}>
            <select
              value={company?.id}
              name="company"
              onChange={handleCompanyChange}
            >
              {companys.length !== 0 &&
                companys.map((data) => {
                  return (
                    <option key={data.id} value={data.id}>
                      {data.name}
                    </option>
                  );
                })}
            </select>
          </div>
        </div>

        <div className={classNames(Styles.payment__info)}>
          <div className={classNames("col-sm-12", "col-md-12", "col-lg-12")}>
            <h4 className={classNames(Styles.payment__info__title)}>
              {maskName(paymentSummary[0]?.caseName)}
            </h4>
            <h4 className={classNames(Styles.payment__info__thirdtitle)}>
              歷史繳費紀錄
            </h4>
            <table style={{ margin: "0 auto" }}>
              <thead>
                <tr>
                  <th className={classNames(Styles.payment__info__table__head)}>
                    月份
                  </th>
                  <th className={classNames(Styles.payment__info__table__head)}>
                    金額
                  </th>
                  <th className={classNames(Styles.payment__info__table__head)}>
                    是否繳款
                  </th>

                  <th
                    className={classNames(Styles.payment__info__table__head)}
                  ></th>
                </tr>
              </thead>

              <tbody>
                {paymentSummary?.map((info, index) => {
                  return (
                    <tr key={index}>
                      <td
                        className={classNames(
                          Styles.payment__info__table__content,
                        )}
                      >
                        {info.month}
                      </td>
                      <td
                        className={classNames(
                          Styles.payment__info__table__content,
                        )}
                      >
                        {Number(info?.amount).toLocaleString()}
                      </td>
                      <td
                        className={classNames(
                          Styles.payment__info__table__content,
                        )}
                      >
                        {info.isPaid === "Y"
                          ? "已繳款"
                          : info.amount === 0
                            ? "無須繳款"
                            : "尚未繳款"}
                      </td>

                      <td
                        className={classNames(
                          Styles.payment__info__table__content,
                        )}
                      >
                        {info.isPaid === "Y" ? (
                          <div
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              handleDownload(info.month, company.id)
                            }
                          >
                            查看收據
                          </div>
                        ) : info.amount === 0 ? (
                          <div>無</div>
                        ) : (
                          <div
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => handleInfoClick(info.month)}
                          >
                            前往繳款
                          </div>
                        )}
                      </td>
                      {/* {company?.id ===4 &&info.isPaid === "Y" && info.amount !== 0 ? (
                        <td
                          className={classNames(
                            Styles.payment__info__table__content,
                          )}
                        >
                          <div
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              handleFetchInvoice(info.month, company.id)
                            }
                          >
                            查看發票
                          </div>
                        </td>
                      ) : null} */}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Summary;
